import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import TestimonialsSection from "./Testimonial";
import Quotes from "./Quotes";
import ContactForm from "./GetInTouch";
import OurImpactCarousel from "./OurImpactCarousel";
import Solve from "./Solve";
import ReportsAndAccess from "./ReportsAndAccess";
import Demo from "./Demo";
import Footer from "../About/Footer";
import Banner from "./Banner";
import GrowthLeadershipSection from "./GrowthLeadershipSection";

const TalentAcquisitionInfo = () => {
  const statsData = [
    {
      number: "43/56",
      description:
        "foundational skills required for job success are human skills",
    },
    {
      number: "97%",
      description:
        "of businesses require people with a mix of technical & human skills",
    },
    {
      number: "2/3",
      description: "of all jobs will be human skill intensive by 2030",
    },
    {
      number: "42.6%",
      description:
        "of Indian graduates are employable, largely due to poor performance in non-technical skills",
    },
  ];

  return (
    <Box sx={{ backgroundColor: "#fff", padding: "20px" }}>
      <Container style={{ padding: "20px", marginTop: "120px", gap: "10px" }}>
        <Banner />
        <GrowthLeadershipSection />
        <Quotes />
        <TestimonialsSection />
        <ContactForm />
        <OurImpactCarousel />
        <Solve />
        <ReportsAndAccess />
        <Demo />
      </Container>
      <Footer />
    </Box>
  );
};

export default TalentAcquisitionInfo;
